import React, { useState, useEffect } from "react";

interface FadeInTextProps {
  projectName: string;
  thinkingText?: string[];
}

const FadeInText: React.FC<FadeInTextProps> = ({ projectName, thinkingText }) => {
  const safeProjectName =
    projectName && projectName.trim() ? projectName : "Project";
  const textLines = thinkingText || [
    "Analysing the input...",
    "Fetching the database Schema...",
    "Generating Query...",
    `Fetching data from ${safeProjectName}...`,
    "Getting a response...",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState<number | null>(null);
  const [showPrev, setShowPrev] = useState(false);
  const [showCurrent, setShowCurrent] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCurrent(false); // hide current before animating prev
      setPrevIndex(currentIndex);
      setShowPrev(true);
      setTimeout(() => {
        setShowPrev(false); // hide prev after animation
        if (currentIndex + 1 < textLines.length) {
          setCurrentIndex(currentIndex + 1); // show next text
        } else {
          setCurrentIndex(0); // loop back to first line
        }
        setShowCurrent(true);
      }, 1000); // wait for animation to finish
    }, 1000);
    return () => clearTimeout(timer);
  }, [currentIndex, textLines.length]);

  return (
    <div className="px-2 py-4">
      <div className="relative h-[20px] w-full overflow-hidden flex items-center">
        {showPrev && prevIndex !== null && (
          <p
            key={prevIndex}
            className="absolute left-0 w-full text-[14px] text-table-body italic font-semibold transition-all duration-1000 opacity-60 -translate-y-6 pointer-events-none"
            style={{ bottom: 0 }}
          >
            {textLines[prevIndex]}
          </p>
        )}
        {showCurrent && (
          <p
            key={currentIndex}
            className="relative w-full text-[14px] text-table-body italic font-semibold transition-all duration-1000 opacity-100 translate-y-0"
            style={{ bottom: 0 }}
          >
            {textLines[currentIndex]}
          </p>
        )}
      </div>
    </div>
  );
};

export default FadeInText;
